export const managerConstant = {
  ALL_MANAGERS: "ALL_MANAGERS",
  GET_MANAGER_NAME_ID: "GET_MANAGER_NAME_ID",
  MANAGER_STATUS: "MANAGER_STATUS",
  MANAGER_MID_LOCATION: "MANAGER_MID_LOCATION",
  LOADER: "LOADER",
  LOCATIONS: "LOCATIONS",
  GET_FILTERED_MANAGERS: "GET_FILTERED_MANAGERS",
  RESET_SEARCH: "RESET_SEARCH",
};
